{
  "CSAT": {
    "TITLE": "Valuta la conversazione",
    "PLACEHOLDER": "Dicci di più...",
    "RATINGS": {
      "POOR": "😞 Scarsa",
      "FAIR": "😑 Sufficiente",
      "AVERAGE": "😐 Nella Media",
      "GOOD": "😀 Buona",
      "EXCELLENT": "😍 Eccellente"
    }
  }
}
